import { FilterList } from "@mui/icons-material";
import {
  Badge,
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Modal,
  Paper,
  Select,
  Tooltip,
  Autocomplete,
  TextField
} from "@mui/material";
import React, { useEffect, useState } from "react";
import axios from "../../CustomAxios";
import { debounce } from "lodash";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function ApUserFilter({
  sortingField,
  sortingOrder,
  setSortingField,
  setSortingOrder,
  apCompany,
  setApCompany,
  setFilter,
  isDeleted,
  setIsDeleted,
}) {
  const [open, setOpen] = useState(false);
  const [count, setCount] = useState(0);
  const [apCompaniesList, setApCompaniesList] = useState([]);
  const [searchApCompany, setSearchApCompany] = useState("");

  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);
    setFilter(true);
  };

  const resetFilters = () => {
    setSortingField("");
    setSortingOrder("");
    setApCompany("");
    setIsDeleted(false);
  };

  useEffect(() => {
    let totalCount = 0;

    if (sortingField) {
      totalCount++;
    }
    if (sortingOrder) {
      totalCount++;
    }
    if (apCompany) {
      totalCount++;
    }
    if (isDeleted) {
      totalCount++;
    }

    setCount(totalCount);
  }, [sortingField, sortingOrder, apCompany, isDeleted]);

  const fetchCompanies = async (search) => {
    try {
      const userData = JSON.parse(localStorage.getItem("AuthData"));
      const config = {
        headers: {
          Authorization: "Bearer " + userData.access_token,
        },
      };

      const url = `/api/v1/${userData?.type}/ap_company?limit=5&search_keyword=${search}`;

      const { data } = await axios.get(url, config);
      if (data.success) {
        setApCompaniesList(data.data.data);
      }
    } catch (e) {
      console.log("error in fetching companies", e);
    }
  };

  const debouncedFetchCompanies = debounce((search) => {
    fetchCompanies(search);
  }, 300);

  useEffect(() => {
    fetchCompanies("");
  }, []);

  useEffect(() => {
    if (searchApCompany) {
      debouncedFetchCompanies(searchApCompany);
    } else {
      fetchCompanies("");
    }
  }, [searchApCompany]);

  return (
    <Paper>
      <Tooltip title="Filters">
        <Badge badgeContent={count} color="error">
          <IconButton onClick={handleOpen} aria-label="Filters" size="small">
            <FilterList />
          </IconButton>
        </Badge>
      </Tooltip>
      <Modal open={open} onClose={handleClose}>
        <Card sx={style} style={{ width: "500px" }}>
          <CardContent>
            <Paper>
              <Grid container spacing={5}>
                <Grid item xs={12} md={12} lg={12}>
                  <Autocomplete
                    options={apCompaniesList}
                    getOptionLabel={(option) => option.name}
                    filterOptions={(options, { inputValue }) => {
                      if (!inputValue) return options;
                      const searchTerm = inputValue.toLowerCase();
                      return options.filter((option) =>
                        option.name.toLowerCase().includes(searchTerm)
                      );
                    }}
                    value={apCompaniesList.find((c) => c._id === apCompany) || null}
                    onChange={(e, newValue) => setApCompany(newValue?._id || "")}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="AP Company"
                        placeholder="Search AP companies..."
                        variant="outlined"
                        onChange={(e) => setSearchApCompany(e.target.value)}
                      />
                    )}
                    fullWidth
                    clearOnBlur={false}
                    sx={{
                      "& .MuiAutocomplete-listbox": {
                        maxHeight: 200,
                      },
                    }}
                  />
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                  <FormControl fullWidth>
                    <InputLabel id="label">Select Sorting Field</InputLabel>
                    <Select
                      labelId="label"
                      fullWidth
                      id="label"
                      label="Select Sorting Field"
                      onChange={(e) => setSortingField(e.target.value)}
                      value={sortingField}
                    >
                      <MenuItem disabled value={""}>
                        Select Sorting Field
                      </MenuItem>
                      <MenuItem value="name">Name</MenuItem>
                      <MenuItem value="created_at">Created At</MenuItem>
                      <MenuItem value="updated_at">Updated At</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                  <FormControl fullWidth>
                    <InputLabel id="label">Select Sorting Order</InputLabel>
                    <Select
                      labelId="label"
                      fullWidth
                      id="label"
                      label="Select Sorting Order"
                      onChange={(e) => setSortingOrder(e.target.value)}
                      value={sortingOrder}
                    >
                      <MenuItem disabled value={""}>
                        Select Sorting Order
                      </MenuItem>
                      <MenuItem value="asc">Ascending</MenuItem>
                      <MenuItem value="desc">Descending</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={12} lg={12}>
                  <FormGroup fullWidth sx={{ ml: 1 }}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={isDeleted}
                          onClick={() => setIsDeleted(!isDeleted)}
                          color="error"
                        />
                      }
                      label="Show Deleted AP Users"
                    />
                  </FormGroup>
                </Grid>
                <Grid item xs={12} md={6} lg={6}>
                  <Button onClick={resetFilters} color="error">
                    Reset All Filter
                  </Button>
                </Grid>
                <Grid
                  container
                  justifyContent={"flex-end"}
                  item
                  xs={12}
                  md={6}
                  lg={6}
                >
                  <Button onClick={handleClose} color="success">
                    OK
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </CardContent>
        </Card>
      </Modal>
    </Paper>
  );
}

export default ApUserFilter;
